import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  // BehaviorSubject holds the current page name and provides it to new subscribers
  private currentPageSubject = new BehaviorSubject<string>('');
  currentPage$ = this.currentPageSubject.asObservable();

  constructor() {}

  // Method to update the current page name
  setCurrentPage(pageName: string): void {
    this.currentPageSubject.next(pageName);
  }
}
